import { render, staticRenderFns } from "./RoleSchedulerTab.vue?vue&type=template&id=2ff31b16&scoped=true&"
import script from "./RoleSchedulerTab.vue?vue&type=script&lang=js&"
export * from "./RoleSchedulerTab.vue?vue&type=script&lang=js&"
import style0 from "./RoleSchedulerTab.vue?vue&type=style&index=0&id=2ff31b16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff31b16",
  null
  
)

export default component.exports